import { render } from "./Home.vue?vue&type=template&id=590577a5&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=590577a5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-590577a5"

export default script